import { object, string } from 'yup';
import { RegexPatterns } from './constants';

export type ProspectFormVariant = 'ZIP' | 'EMAIL_ZIP' | 'FULL';

export const getProspectFormSchema = (variant?: ProspectFormVariant) => {
  const baseSchema = {
    zipCode: string()
      .matches(RegexPatterns.ZIP_CODE, 'Please enter a valid Zip code')
      .required('Zip code is required')
      .defined()
      .trim(),
  };

  switch (variant) {
    case 'ZIP':
      return object(baseSchema);
    case 'EMAIL_ZIP':
      return object({
        ...baseSchema,
        email: string()
          .email('Please enter a valid email')
          .required('Email is required')
          .defined()
          .trim(),
      });
    case 'FULL':
      return object({
        ...baseSchema,
        email: string()
          .email('Please enter a valid email')
          .required('Email is required')
          .defined()
          .trim(),
        name: string().required('Name is required').defined().trim(),
      });
    default:
      return object(baseSchema);
  }
};
